import Swiper from "swiper";

/** Block Home Slider */
export function blockHomeSlider() {
  new Swiper(".home-slider__swiper", {
    direction: "horizontal",
    slidesPerView: 1, 
    spaceBetween: 0,
  });
}
